import api from 'Application/api/api';

const getUnusedStatisticsOptions = signal =>
	api.get('/step-templates/unused-statistics-options', {
		signal,
	});

export default getUnusedStatisticsOptions;
